import SharedSupportChat from "../chat/SupportChat.jsx";
import { listSupportMessages, postSupportMessage } from "../../lib/adminApi";

const adminApi = {
  listMessages: (id) => listSupportMessages(id),
  postMessage: (id, body) => postSupportMessage(id, body),
};

export default function SupportChat({ ticket, locked, onTicketUpdated }) {
  return (
    <SharedSupportChat
      ticket={ticket}
      role="admin"
      api={adminApi}
      locked={locked}
      onTicketUpdated={onTicketUpdated}
    />
  );
}
